module.exports = __webpack_public_path__ + "static/img-phone-1319a60b8cd862d699a47af964c373bd.svg";